<template>
  <v-dialog v-model="dialog" @click:outside="close" width="750" persistent>
    <v-card>
      <v-card-title>
        <span class="headline"> Consumo Adicional</span>
      </v-card-title>

      <v-card-text>
        <v-combobox
          v-model="item.type"
          data-vv-as="Tipo"
          name="type"
          :items="types"
          item-text="name"
          item-value="id"
          label="Tipo*"
          v-validate="'required'"
          @change="onTypeChange"
        ></v-combobox>
        <span class="red--text">{{ errors.first("type") }}</span>

        <!-- Mostrar combobox según el tipo seleccionado -->
        <div v-if="item.type && item.type.id === 'M'">
          <v-combobox
            v-model="item.raw_material"
            data-vv-as="Materia Prima"
            name="raw_material"
            item-text="name"
            item-value="id"
            :items="raw_materials"
            label="Materia Prima*"
            autocomplete="off"
            v-validate="item.type && item.type.id === 'M' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("raw_material") }}</span>
        </div>

        <div v-if="item.type && item.type.id === 'R'">
          <v-combobox
            v-model="item.resource"
            data-vv-as="Recurso"
            name="resource"
            item-text="name"
            item-value="id"
            :items="resources"
            label="Recurso*"
            autocomplete="off"
            v-validate="item.type && item.type.id === 'R' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("resource") }}</span>
        </div>

        <div v-if="item.type && item.type.id === 'S'">
          <v-combobox
            v-model="item.formula"
            data-vv-as="Formula Semi-elaborada"
            name="formula"
            item-text="name"
            item-value="id"
            :items="formulas"
            label="Formula Semi-elaborada*"
            autocomplete="off"
            v-validate="item.type && item.type.id === 'S' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("formula") }}</span>
        </div>

        <div v-if="item.type && item.type.id === 'P'">
          <v-combobox
            v-model="item.product"
            data-vv-as="Producto"
            name="product"
            item-text="label"
            item-value="id"
            :items="products"
            label="Producto*"
            autocomplete="off"
            v-validate="item.type && item.type.id === 'P' ? 'required|combobox_required' : ''"
          ></v-combobox>
          <span class="red--text">{{ errors.first("product") }}</span>
        </div>

        <div v-if="item.type && item.type.id === 'M'">
          <v-combobox
            v-model="item.mp_product_presentation_used"
            data-vv-as="Producto"
            name="mp_product_presentation_used"
            :item-text="presentationLabel"
            item-value="id"
            :items="getPresentationsForCurrentRawMaterial()"
            label="Producto"
            autocomplete="off"
            clearable
            :disabled="!item.raw_material"
          ></v-combobox>
        </div>

        <v-text-field
          autocomplete="off"
          name="valor_utilizado"
          label="Cantidad Utilizada*"
          type="number"
          step="0.01"
          v-model="item.valor_utilizado"
          v-validate="'required|decimal|min_value:0.01'"
          data-vv-as="Cantidad Utilizada"
        />
        <span class="red--text">{{ errors.first("valor_utilizado") }}</span>

        <v-text-field
          autocomplete="off"
          name="costo_base"
          label="Costo Base"
          type="number"
          step="0.01"
          prefix="$"
          v-model="item.costo_base"
          data-vv-as="Costo Base"
          readonly
        />

        <v-text-field
          autocomplete="off"
          name="costo_unitario_utilizado"
          label="Costo Unitario Utilizado*"
          type="number"
          step="0.01"
          prefix="$"
          v-model="item.costo_unitario_utilizado"
          v-validate="'required|decimal|min_value:0'"
          data-vv-as="Costo Unitario Utilizado"
        />
        <span class="red--text">{{ errors.first("costo_unitario_utilizado") }}</span>

        <v-textarea
          autocomplete="off"
          name="observacion"
          label="Observaciones"
          v-model="item.observacion"
          rows="3"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close"> Cerrar </v-btn>
        <v-btn color="success" text @click="save"> {{ isEdit ? 'Guardar' : 'Agregar' }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import { formulaService } from "@/libs/ws/formulaService";
import ConstantSections from "@/constants/sections";
import { FORMULA_ITEM_TYPE_CONFIG as TYPE_CONFIG } from "@/constants/formulaItemTypes";

export default {
  props: {
    dialog: Boolean,
    itemEdit: Object,
    editIndex: Number,
  },
  data: () => ({
    item: {
      type: null,
      mp_product_presentation_used: null,
      nombre: null,
      valor_utilizado: null,
      observacion: null,
      resource: null,
      raw_material: null,
      formula: null,
      product: null,
      costo_base: 0,
      costo_unitario_utilizado: 0,
    },
    defaultItem: null,
    types: [],
    resources: [],
    raw_materials: [],
    formulas: [],
    products: [],
    presentationsByRawMaterial: {},
  }),
  computed: {
    isEdit() {
      return this.itemEdit != null && this.editIndex != null;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.errors.clear();
        if (this.itemEdit != null) {
          this.item = Object.assign({}, this.itemEdit);
          // Reconstruir el objeto type desde tipo
          if (this.item.tipo) {
            this.item.type = this.types.find(t => t.id === this.item.tipo);
          }
        } else {
          this.item = Object.assign({}, this.defaultItem);
        }
      }
    },
    'item.raw_material': function(newValue, oldValue) {
      if (newValue && newValue.id) {
        // Cargar las presentaciones para esta materia prima
        this.loadPresentationsForRawMaterial(newValue.id).then(() => {
          // Una vez cargadas las presentaciones, auto-seleccionar si existe product_presentation
          if (newValue.product_presentation) {
            this.item.mp_product_presentation_used = newValue.product_presentation;
          } else {
            // Si cambió de materia prima, limpiar el producto seleccionado
            if (oldValue && oldValue.id !== newValue.id) {
              this.item.mp_product_presentation_used = null;
            }
          }
        });
        
        // Calcular costo base para materia prima
        this.calculateCostoBase();
      } else {
        // Si se limpia la materia prima, limpiar también el producto
        this.item.mp_product_presentation_used = null;
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
      }
    },
    'item.resource': function(newValue) {
      if (newValue) {
        // Calcular costo base para recurso
        this.calculateCostoBase();
      } else {
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
      }
    },
    'item.formula': function(newValue) {
      if (newValue) {
        // Calcular costo base para semi-elaborado (si aplica)
        this.calculateCostoBase();
      } else {
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
      }
    },
    'item.product': function(newValue) {
      if (newValue) {
        // Calcular costo base para producto
        this.calculateCostoBase();
      } else {
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
      }
    }
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.loadResources();
    this.loadRawMaterials();
    this.loadFormulas();
    this.loadProducts();
    this.loadTypesFormulasItems();
  },
  methods: {
    loadTypesFormulasItems() {
     formulaService
        .list_types_formula_items()
        .then((response) => {
          this.types = response.result;  
        })
        .catch((e) => {
          console.log("types.list error");
          console.log(e);
        });
    },
    onTypeChange() {
      // Limpiar todas las referencias excepto la del tipo seleccionado
      const selectedTypeId = this.item.type?.id;
      Object.keys(TYPE_CONFIG).forEach(typeId => {
        if (typeId !== selectedTypeId) {
          const config = TYPE_CONFIG[typeId];
          this.item[config.entityKey] = null;
          this.errors.remove(config.entityKey);
        }
      });
      
      // Limpiar mp_product_presentation_used si no es tipo M
      if (selectedTypeId !== 'M') {
        this.item.mp_product_presentation_used = null;
      }
      
      // Limpiar costos al cambiar tipo
      this.item.costo_base = 0;
      this.item.costo_unitario_utilizado = 0;
    },
    calculateCostoBase() {
      const typeId = this.item.type ? this.item.type.id : null;
      const config = TYPE_CONFIG[typeId];
      
      if (!config || !config.costPath) {
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
        return;
      }
      
      const entity = this.item[config.entityKey];
      if (!entity) {
        this.item.costo_base = 0;
        this.item.costo_unitario_utilizado = 0;
        return;
      }
      
      // Obtener el costo usando la ruta especificada en config.costPath
      // El costPath incluye la entidad (ej: 'resource.costo_unitario')
      // pero necesitamos solo la parte después de la entidad (ej: 'costo_unitario')
      const pathParts = config.costPath.split('.');
      const pathWithoutEntity = pathParts.slice(1); // Remover la primera parte (nombre de entidad)
      
      let costValue;
      if (pathWithoutEntity.length > 0) {
        costValue = pathWithoutEntity.reduce((acc, part) => acc?.[part], entity);
      } else {
        // Si no hay path después de la entidad, tomar directamente
        costValue = entity[pathParts[0]];
      }
      
      this.item.costo_base = parseFloat(costValue) || 0;
      this.item.costo_unitario_utilizado = this.item.costo_base;
    },
    loadResources() {
      generalService.setSection(ConstantSections.SECTION_RESOURCES);
      generalService
        .filter()
        .then((response) => {
          this.resources = response.result;
        })
        .catch((e) => {
          console.log("resources.filter error", e);
        });
    },
    loadRawMaterials() {
      generalService.setSection(ConstantSections.SECTION_RAW_MATERIALS);
      generalService
        .filter()
        .then((response) => {
          this.raw_materials = response.result;
        })
        .catch((e) => {
          console.log("raw_materials.filter error", e);
        });
    },
    loadFormulas() {
      formulaService
        .filter_semi_elaboradas()
        .then((response) => {
          this.formulas = response.result;
        })
        .catch((e) => {
          console.log("formulas.filter_semi_elaboradas error", e);
        });
    },
    loadProducts() {
      const params = {};
      generalService.setSection(ConstantSections.SECTION_PRODUCTS);
      generalService
        .query(params, ConstantSections.SECTION_PRODUCTS + "/presentations")
        .then((response) => {
          this.products = response.result;
        })
        .catch((e) => {
          console.error("Error loading presentations:", e);
        });
    },
    loadPresentationsForRawMaterial(rawMaterialId) {
      // Si ya están cargadas, resolver inmediatamente
      if (!rawMaterialId) {
        return Promise.resolve();
      }
      
      if (this.presentationsByRawMaterial[rawMaterialId]) {
        return Promise.resolve();
      }

      const params = {
        raw_material_id: rawMaterialId,
        buyable: true
      };

      generalService.setSection(ConstantSections.SECTION_PRODUCTS);
      return generalService
        .query(params, ConstantSections.SECTION_PRODUCTS + "/presentations")
        .then((response) => {
          this.$set(this.presentationsByRawMaterial, rawMaterialId, response.result);
        })
        .catch((e) => {
          console.log("presentations.filter error", e);
        });
    },
    getPresentationsForCurrentRawMaterial() {
      if (this.item.type && this.item.type.id === 'M' && this.item.raw_material && this.item.raw_material.id) {
        return this.presentationsByRawMaterial[this.item.raw_material.id] || [];
      }
      return [];
    },
    presentationLabel(item) {
      return item.label || item.name;
    },
    save() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          // Determinar qué unidad usar según el tipo usando TYPE_CONFIG
          let storage_unit_id = null;
          let resource_unit_id = null;
          
          const typeId = this.item.type?.id;
          const config = TYPE_CONFIG[typeId];
          
          if (config && this.item[config.entityKey]) {
            const entity = this.item[config.entityKey];
            const unitKey = config.unitKey;
            
            if (unitKey === 'resource_unit') {
              resource_unit_id = entity[unitKey]?.id || null;
            } else if (unitKey === 'storage_unit') {
              if (typeId === 'M') {
                storage_unit_id = entity.storage_unit?.id || null;
              } else if (typeId === 'P') {
                storage_unit_id = entity.storage_unit?.id || null;
              } else if (typeId === 'S' && entity.product_final?.base_presentation?.storage_unit) {
                storage_unit_id = entity.product_final.base_presentation.storage_unit.id;
              }
            }
          }
          
          const itemToSave = {
            ...this.item,
            storage_unit_id: storage_unit_id,
            resource_unit_id: resource_unit_id,
            costo_base: parseFloat(this.item.costo_base) || 0,
            costo_unitario_utilizado: parseFloat(this.item.costo_unitario_utilizado) || 0,
          };
          
          if (this.isEdit) {
            this.$emit("updateItem", itemToSave, this.editIndex);
          } else {
            this.$emit("addItem", itemToSave);
          }
          
          this.close();
        }
      });
    },
    close() {
      this.$emit("updateDialog", false);
      this.item = Object.assign({}, this.defaultItem);
    },
  },
};
</script>

<style scoped>
</style>
